import { Controller } from '@hotwired/stimulus';

import useAuthenticatedUser from '../../stimulus-composables/authenticated-user';

/**
 * Show/hide elements if the current user is anonymous/authenticated.
 * Be aware that code will still be in DOM.
 */
export default class extends Controller {
    static targets = ['anonymous', 'authenticated'];

    static classes = ['anonymousVisible', 'anonymousHidden', 'authenticatedVisible', 'authenticatedHidden'];

    connect() {
        useAuthenticatedUser(this, this.#toggleContent);
    }

    #toggleContent = (user) => {
        const isConnected = user?.content?.connected;

        this.anonymousTargets.forEach((element) => {
            if (isConnected) {
                element.classList.remove(...this.anonymousVisibleClasses);
                element.classList.add(...this.anonymousHiddenClasses);
            } else {
                element.classList.remove(...this.anonymousHiddenClasses);
                element.classList.add(...this.anonymousVisibleClasses);
            }
        });

        this.authenticatedTargets.forEach((element) => {
            if (isConnected) {
                element.classList.remove(...this.authenticatedHiddenClasses);
                element.classList.add(...this.authenticatedVisibleClasses);
            } else {
                element.classList.remove(...this.authenticatedVisibleClasses);
                element.classList.add(...this.authenticatedHiddenClasses);
            }
        });
    };
}
